<div class="" style="display: flex; flex-direction: column; justify-content: space-between; min-height: 95vh;">
	<div>
		<ng-container *ngIf="purchase_info">
			<div class="row border-bottom">
				<div class="col-3 align-items-center mb-3">
					<img [src]="rest.getImagePath(store?.ticket_image_id, rest.local_preferences.default_ticket_image_id, rest.local_preferences.logo_image_id)" class="company-logo ms-3" style="width:100%;max-width:700px;vertical-align:top">
				</div>
				<div class="col-6 align-items-center text-center pb-3">
					<h6 *ngIf="billing_data?.razon_social || store?.business_name" class="fw-bold">
						{{(billing_data?.razon_social || store?.business_name) | uppercase}}
					</h6>
					<div *ngIf="billing_data?.rfc || store?.rfc">
						RFC {{(billing_data?.rfc || store?.rfc) | uppercase}}
					</div>
					<div>
						<span *ngIf="billing_data?.address || store?.address">{{(billing_data?.address || store?.address) | uppercase}}</span>
						<ng-container *ngIf="(billing_data?.address || store?.address) && (billing_data?.city || store?.city)">, </ng-container>
						<span *ngIf="billing_data?.city || store?.city">{{(billing_data?.city || store?.city) | uppercase}}</span>
						<span *ngIf="billing_data?.state || store?.state">, {{(billing_data?.state || store?.state) | uppercase}}</span>
						<span *ngIf="billing_data?.zipcode || store?.zipcode"> CP: {{billing_data?.zipcode || store?.zipcode}}</span>
					</div>
					<div *ngIf="billing_data?.regimen_fiscal">
						{{billing_data.regimen_fiscal}}
					</div>
					<div *ngIf="store?.name">
						Sucursal: {{store.name | titlecase}}
					</div>
					<div *ngIf="store?.phone">Teléfono: {{store.phone}}</div>
				</div>
				<div class="col-3 align-items-center text-end pe-4">
					<h2 class="fw-bold mb-2">{{purchase_info?.purchase?.id}}</h2>
					<div>{{purchase_info?.purchase?.created | date: 'MMMM d, y' }}</div>
					<div *ngIf="currency_rate">
						<b>T.C.:</b> {{currency_rate.rate | number: '1.4-4'}}
					</div>
					<div>
						<b>Moneda</b> {{(currency?.name || purchase_info?.bill?.currency_id) | uppercase}}
					</div>
				</div>
			</div>

			<div class="text-center my-3">
				<h3 class="fw-bold">ORDEN DE COMPRA</h3>
			</div>

			<div class="row mx-0 border rounded mb-3" *ngIf="purchase_info?.purchase?.provider_name || provider_address">
				<div class="col-12 bg-light fw-bold py-1">Proveedor:</div>
				<div class="col-12 py-1">
					{{purchase_info?.purchase?.provider_name | uppercase}}
				</div>
				<div class="col-12 py-1" *ngIf="provider_address">
					<span *ngIf="provider_address.address">{{provider_address.address}}</span>
					<span *ngIf="provider_address.suburb">, {{provider_address.suburb}}</span>
					<span *ngIf="provider_address.city"> {{provider_address.city}}</span>
					<span *ngIf="provider_address.state"> {{provider_address.state}}</span>
					<span *ngIf="provider_address.country"> {{provider_address.country}}</span>
				</div>
			</div>

			<div class="px-1 px-lg-3 py-2">
				<table class="table table-sm purchase-items-table">
					<thead>
						<tr class="border-bottom fw-bold">
							<th class="text-end">Cantidad</th>
							<th>Unidad</th>
							<th>Clave</th>
							<th>Producto</th>
							<th class="text-end">P. Unitario</th>
							<th class="text-end">Importe</th>
							<th class="text-end" *ngIf="show_iva_column">IVA</th>
							<th class="text-end">Total</th>
						</tr>
					</thead>
					<tbody>
						<tr class="border-bottom" *ngFor="let pdi of purchase_info.details">
							<td class="text-end text-nowrap">{{pdi.purchase_detail.qty | number}}</td>
							<td class="text-nowrap">{{(pdi.item?.measurement_unit || 'PIEZA') | uppercase}}</td>
							<td class="text-nowrap">{{pdi.item?.code}}</td>
							<td>{{pdi.item?.name | uppercase}}</td>
							<td class="text-end text-nowrap">{{pdi.purchase_detail.unitary_price | number: '1.2-2'}}</td>
							<td class="text-end text-nowrap">{{getRowImporte(pdi) | number: '1.2-2'}}</td>
							<td class="text-end text-nowrap" *ngIf="show_iva_column">{{getRowIva(pdi) | number: '1.2-2'}}</td>
							<td class="text-end text-nowrap">{{getRowTotal(pdi) | number: '1.2-2'}}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="row mt-3 mx-0">
				<div class="col-7 d-flex align-items-end">
					<div class="w-100">
						<div class="fw-bold">Importe en letra</div>
						<div class="fst-italic">{{total_letra}}</div>
					</div>
				</div>
				<div class="col-5">
					<table class="totals-table ms-auto">
						<tbody>
							<tr *ngIf="show_iva_column">
								<td class="text-end fw-bold pe-3">Importe</td>
								<td class="text-end text-nowrap">{{subtotal | number: '1.2-2'}}</td>
							</tr>
							<tr>
								<td class="text-end fw-bold pe-3">Subtotal</td>
								<td class="text-end text-nowrap">{{subtotal | number: '1.2-2'}}</td>
							</tr>
							<tr *ngIf="show_iva_column">
								<td class="text-end fw-bold pe-3">I.V.A.</td>
								<td class="text-end text-nowrap">{{iva | number: '1.2-2'}}</td>
							</tr>
							<tr class="totals-total-row">
								<td class="text-end fw-bold pe-3">TOTAL</td>
								<td class="text-end fw-bold text-nowrap">{{total | number: '1.2-2'}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="row mx-0 mt-3" *ngIf="purchase_info?.bill?.note">
				<div class="col-12 p-2 border-top">
					<b>NOTA:</b> <span>{{purchase_info.bill.note}}</span>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div class="d-print-none py-3 text-center">
	<button type="button" (click)="printDirect()" class="my-3 btn btn-primary">Imprimir</button>
	<button type="button" (click)="goBack()" class="my-3 btn btn-primary ms-2">Regresar</button>
</div>
